const statusLabelMap: { [key: string]: string } = {
  unknown: 'Unknown',
  no_match: 'No Match',
  false_positive: 'False Positive',
  true_positive: 'True Positive',
  potential_match: 'Potential Match'
}

export const getAdverseInformationHitMatchStatusLabel = (name: string): string => statusLabelMap[name] || name
